import { Pipe, PipeTransform } from '@angular/core';
import { format, asYouType } from 'libphonenumber-js';

@Pipe({
    name: 'phoneFormatInputPipe',
})

export class phoneFormatInputPipe implements PipeTransform {
    transform(value: any, code: any, useOldFormat?: any) {
        if (code && (useOldFormat || (code !== 'US' && code !== 'CA'))) {
            value = format(value, code, 'International');
            return this.transformInternational(value);
        } else if (code) {
            return this.transformNational(value, code);
        } else {
            return null;
        }
    }

    transformInternational(number: any) {
        let value: any = new asYouType().input(number);
        if (number && (value.length < 5 || value.indexOf(' ') !== -1)) {
            return value;
        } else if (number) {
            number = number.substring(0, number.length - 1);
            value = new asYouType().input(number);
            return value;
        }
        return null;
    }

    transformNational(number: any, code: any) {
        if (number) {
            if (number.indexOf('+1') !== -1) {
                number = number.replace('+1', '');
            }

            let cleaned = ('' + number.replace(/\D/g, '')).slice(0, 10);
            let formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const middle = cleaned.substring(3, 6);
            const last = cleaned.substring(6, 10);

            if (cleaned.length > 6) {
                formattedVal = `${zip}-${middle}-${last}`;
            } else if(cleaned.length > 3) {
                formattedVal = `${zip}-${middle}`;
            } else if(cleaned.length > 0) {
                formattedVal = `${zip}`;
            }

            return formattedVal;
        }
        return null;

        // let value: any = new asYouType(code).input(number);
        // // delete on backspace
        // if (number && number.length < value.length && number.length > 1 && number.length < 5) {
        //     return number;
        // }
        // if (number && (value.length < 7 || value.indexOf(' ') !== -1)) {
        //     return value;
        // } else if (number) {
        //     number = number.substring(0, number.length - 1);
        //     value =  new asYouType(code).input(number);
        //     return value;
        // }
        // return null;
    }
}